var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBasicPlan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 23.1574C18.9945 22.9476 21.0055 22.9476 23 23.1574M12.2308 26.3766C12.2542 26.4752 12.2973 26.568 12.3575 26.6495C12.4177 26.731 12.4937 26.7995 12.5811 26.8509C12.6684 26.9022 12.7653 26.9353 12.8657 26.9483C12.9662 26.9612 13.0683 26.9537 13.1658 26.9262C17.6367 25.6918 22.3584 25.6913 26.8295 26.9249C26.927 26.9524 27.029 26.9599 27.1295 26.947C27.2299 26.934 27.3267 26.9009 27.4141 26.8496C27.5014 26.7983 27.5774 26.7298 27.6376 26.6484C27.6978 26.5669 27.7409 26.4741 27.7643 26.3756L30.1539 16.2209C30.1859 16.0849 30.1793 15.9427 30.1348 15.8103C30.0904 15.678 30.0098 15.5606 29.9023 15.4715C29.7948 15.3824 29.6645 15.3251 29.5261 15.3061C29.3878 15.287 29.2468 15.307 29.1192 15.3637L24.377 17.4714C24.2058 17.5475 24.0122 17.5567 23.8345 17.4973C23.6568 17.4378 23.5078 17.314 23.4168 17.1502L20.6556 12.1801C20.5907 12.0632 20.4956 11.9658 20.3803 11.898C20.2651 11.8301 20.1337 11.7944 20 11.7944C19.8662 11.7944 19.7349 11.8301 19.6196 11.898C19.5044 11.9658 19.4093 12.0632 19.3444 12.1801L16.5832 17.1502C16.4922 17.314 16.3432 17.4378 16.1655 17.4973C15.9878 17.5567 15.7942 17.5475 15.623 17.4714L10.88 15.3634C10.7524 15.3067 10.6116 15.2867 10.4732 15.3057C10.3349 15.3248 10.2046 15.382 10.0971 15.4711C9.98955 15.5601 9.909 15.6775 9.86452 15.8098C9.82003 15.9422 9.81338 16.0843 9.84531 16.2202L12.2308 26.3766Z",
    stroke: "#D3D7D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBasicPlan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/basic-plan.98d4998bd53491076a0c2d61616c9cb3.svg";